import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import UpgradeLicenseForm from "../../forms/UpgradeLicenseForm";

const UpgradeLicenseModal = ({ open, onClose, license, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit: ${license.clientInfo} license.`}
      width="md"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <UpgradeLicenseForm license={license} loading={loading} />
    </AppModal>
  );
};

export default UpgradeLicenseModal;
